// REDUX
import { useDispatch } from "react-redux";
import { updateOperationMEPModal } from "../../../../store/slices/operationMEPSlice";
import { useAppSelector } from "../../../../store/hooks";

// STYLES
import styles from "./BackHeader.module.scss";

// ICONS
import ArrowLeftIcon from "../../../../assets/icons/arrow-left.svg?react";

interface Props {
  onClose: () => void;
  showButton?: boolean;
  customSideButton?: { action: () => void; icon?: JSX.Element };
}

export const BackHeader = ({
  onClose,
  showButton = true,
  customSideButton,
}: Props) => {
  const { operationState } = useAppSelector((state) => state.operationMEPData);

  const dispatch = useDispatch();

  const onGoBack = () => {
    switch (operationState) {
      case "DRAFT":
        onClose();
        return;
      case "REVIEW":
        dispatch(updateOperationMEPModal("DRAFT"));
        return;
      case "DETAILS":
        dispatch(updateOperationMEPModal("DRAFT"));
        return;
      default:
        return;
    }
  };

  const getTitle = () => {
    switch (operationState) {
      case "DRAFT":
        return "Operar";
      case "REVIEW":
        return "Preconfirmación de operación";
      case "DETAILS":
        return "Detalle de operación";
      default:
        return "";
    }
  };

  const {
    headerContainer,
    backButton,
    titleText,
    arrowIcon,
    addMarginLeft,
    customButtonContainer,
  } = styles;

  return (
    <div className={headerContainer}>
      {showButton && (
        <div
          className={backButton}
          onClick={onGoBack}
          aria-label="Volver atrás"
        >
          <ArrowLeftIcon className={arrowIcon} />
        </div>
      )}
      <p className={`${titleText} ${!showButton && addMarginLeft}`}>
        {getTitle()}
      </p>
      {customSideButton && (
        <div
          className={customButtonContainer}
          onClick={customSideButton.action}
        >
          {customSideButton.icon}
        </div>
      )}
    </div>
  );
};
